import React from "react";

export type UserUpdate = Record<string, unknown>;

/**
 * Merges a patch into the signed-in user held by `WithUserContext` (src/pages/index.js), so a saved
 * profile change (language, FCL) shows without a reload. Separate from UserContext so its value
 * keeps the plain user shape that components and tests rely on.
 */
const UserUpdateContext = React.createContext<(patch: UserUpdate) => void>(() => {});
UserUpdateContext.displayName = "UserUpdateContext";

export default UserUpdateContext;
